<template>
    <div class="body">
		<p  class="font1" style="padding-top: 8vh;">在追求知识的道路上，ESG课程引领我们关注全球责任。让我们共同践行，成就美好未来！</p>

		<div class="wrapper">
            <div class="pcfont" style="width: 90%;margin: 0 auto;margin-top: 2vh;">
                <p style="margin: 0 auto; font-size: 20px;color: #000;">EHS+ESG 12月主题课程推荐：</p>
                <ul style="list-style: none;">
                    <li v-for="(course, index) in courses" :key="index">
                        <label>
                            <input type="checkbox" :value="course" v-model="selectedCourses"/>
                            {{ course }}
                        </label>
                    </li>
                </ul>
            </div>
            <div class="pcfont" style="width: 87%;margin: 0 auto;margin-top: 3vh;" v-if="coc">
                <p style="margin: 0 auto; font-size: 20px;color: #000;">必修课程完成情况：</p>
                <ul v-for="(item,index) in coc" :key="index" ref="">
                    <a @click="redirectToESG(item.Name, item.link)" style="text-decoration: none;color: #000;">
                        <li style="padding: 0;margin-top: 0;">{{ item.Name }}&nbsp;
                            <span v-if="item.iscompleted" style="color: green;font-weight: 800;">已完成</span>
                            <span v-else style="color: red;font-weight: 800;">未完成</span>
                        </li>
                    </a>
                </ul>
            </div>
        </div>
    </div>
</template>
  
<script>
export default {
    props: {
        ReportData: {
            type: Object,
            required: false
        },
        selected: {
            type: Array,
            default: () => []
        }
    },
    data() {
		return {
			coc:[],
            courses: ['女职工权益维护','工会帮扶政策介绍','职场不法侵害危害预防教育训练','女职工权利保障与风险防范','CSR与劳工人权','未成年工、学生工及女工管理','员工健康关爱知识普及'],
            selectedCourses: []
		}
    }, 
    created(){
		if(this.ReportData.coc !== null){
			this.coc=JSON.parse(this.ReportData.coc)
            // console.log(this.coc,'coc')
		}
    },
    watch: {
        selectedCourses: {
            deep: true,
            handler(newVal) {
                this.$emit('update:selected', newVal);
            }
        }
    },
    mounted() {
        this.selectedCourses = [...this.selected];
    }
}
</script>
  
<style scoped>
.body {
	background: 
        url("../../assets/25November/logo.png") right  top  no-repeat,
        url("../../assets/25November/bg.jpg")  no-repeat;
	background-size: 100% 100%,cover;
	width: 100%;
	height: 100vh;
}

ul{
    list-style-type: none;
    list-style: none;
    padding: 0;
    color: #000;
    margin: 0;
    /* text-align: center; */
}

li {
    align-items: center;
    /* margin-bottom: 1px;  */
}

li::before {
    /* content: '\2022'; 
    color: #000;  */
    font-size: 1.5em; /* 可调整小圆点的大小 */
    margin-right: 3px; /* 可调整小圆点与文字之间的间距 */
    margin: 0 auto;
}

.font1 {
    width: 96%;
    margin: 0 auto;
    text-align: center;
    font-size: 20px;
    color: #d03327;
    font-weight: bold;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}

.font2 { 
    width: 96%;
    margin: 0 auto;
    text-align: center;
    padding: 0;
    color: #fff;
    font-size: 17px;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}

.font3 {
    font-size: 20px;
    font-weight: bold;
    color: #64892f;
    text-shadow:  -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
@media screen and (min-width: 786px) {
  .body {
    background: 
                url("../../assets/25November/pcbg.jpg")  no-repeat;
    background-size:cover;
    width: 100%;
    height: 100vh;
  }
  .wrapper {
    width: 90%;
    margin: 0 auto;
    font-size: 19px;
  }
  .pcfont{
    font-size: 19px;
  }
}
</style>